/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {removeDevices} from '../api'

export const useMutationRemoveDevices = createReactQueryMutationHook('removeDevices', removeDevices)
